import { cn } from "@/lib/utils";

export default function WinnerCardTitle({
  competitionTitle,
  winnerName,
  isSubscriberCompetition,
}: {
  competitionTitle: string;
  winnerName?: string;
  isSubscriberCompetition: boolean;
}) {
  const titleClass = "!mb-0 text-left normal-case font-jost text-lg font-semibold leading-6 text-dark-1 min-h-[48px]";

  if (!winnerName || isSubscriberCompetition) {
    return (
      <div className={titleClass}>
        <div className="line-clamp-2 break-words">{competitionTitle}</div>
      </div>
    );
  }

  return (
    <div className={cn(`flex flex-wrap items-baseline min-w-0 ${titleClass}`)}>
      <span className="inline-flex items-baseline min-w-0 max-w-full shrink-0">
        <span className="min-w-0 max-w-full line-clamp-2 break-words">{competitionTitle}</span>
        <span className="mx-1.5 shrink-0 text-primary">·</span>
      </span>
      <span className="shrink-0 whitespace-nowrap text-secondary">Winner {winnerName}</span>
    </div>
  );
}
